import { formatMoney } from 'accounting'

import {
  faCheckCircle, faCog, faPencil, faTrashAlt,
} from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  Box, Button, Checkbox, IconWithMenu, Link, ListItem, Text,
} from '@domain-group/suit-theme'

import { useSetState } from '@domain-group/react-hooks'

import useCampaignContribution from '@hooks/useCampaignContribution'
import { generateUrls } from '@hooks/useCampaign'

import handleCallbackAction from '@functions/handleCallbackAction'
import { confirmDelete } from '@functions/entity'
import { getPaymentMethodByKey } from '@functions/campaignContribution'

import type { CampaignContributionModel } from '@models/types'

const defaultState = {
  updating: false,
}

const ContributionsListItem = (props: {campaignContribution: CampaignContributionModel}) => {
  const { campaignContribution } = props

  const [state, setState] = useSetState(defaultState)
  const { updating } = state

  const campaignContributionPayload = useCampaignContribution(campaignContribution)

  const {
    callbacks: {
      deleteCampaignContribution: deleteFn,
      updateCampaignContribution: updateFn,
    },
    campaign,
    campaign: {
      // @ts-expect-error TS2339
      address,
      // @ts-expect-error TS2339
      suburb_name,
    },
    campaignContribution: {
      amount,
      dates: {
        received,
      },
      paid_by,
      payment_method,
      payment_received,
      reference,
    },
  } = campaignContributionPayload

  // @ts-expect-error TS2345
  const paymentMethod = getPaymentMethodByKey(payment_method)

  // @ts-expect-error TS2339
  const { campaignAccountingUrl } = generateUrls({ id: campaign.id })

  const updateCampaignContributionPayload = {
    callbacks: {
      action: updateFn,
      afterAction: () => setState({ updating: false }),
      afterError: () => setState({ updating: false }),
    },
    entityParams: { id: campaignContribution.id, payment_received: !payment_received },
    toastText: 'Contribution Updated',
  }

  const confirmDeletePayload = {
    callbacks: {
      deleteFn,
    },
    strings: {
      confirmString: 'Are you sure? This cannot be undone.',
      entityName: 'Campaign Contribution',
    },
  }

  return (
    <Box
      marginBottom="large"
      variant="white"
      flexDirection="column"
    >
      {/*
       // @ts-expect-error TS2339 */}
      <ListItem.WithCheckbox
        boxProps={{
          paddingX: 'large',
          paddingTop: 'medium',
          paddingBottom: 'medium',
        }}
        checkbox={(
          <Checkbox
            checked={payment_received}
            fontSize="small"
            style={{ cursor: 'auto' }}
          />
          )}
        disableHover
      >
        <Box flexDirection="column" marginRight="auto" width={['150px', 'auto']}>
          <Text fontSize="small" marginRight="large" variant="ellipsis">
            {address}, {suburb_name}
          </Text>

          <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small" variant="ellipsis">
            {reference}
          </Text>
        </Box>

        <Box justifyContent="flex-end">
          <Button
            buttonStyle={payment_received ? 'secondaryCreate' : 'secondaryUtility'}
            icon={<FontAwesomeIcon icon={faCheckCircle} />}
            loading={updating}
            onClick={() => {
              setState({ updating: true })
              handleCallbackAction(updateCampaignContributionPayload)
            }}
            size="small"
            width="auto"
          >
            {payment_received ? 'Received' : 'Mark as Received'}
          </Button>
        </Box>
        {/*
       // @ts-expect-error TS2339 */}
      </ListItem.WithCheckbox>

      <Box alignItems="center" justifyContent="space-between" padding="large">
        <Box flexDirection="column" fontSize="xsmall" justifyContent="center" maxWidth="50%">
          <Text color="faintGrey" variant="ellipsis">
            Received {received.date}
          </Text>

          <Text color="bodyFontLightColor" marginTop="small" variant="ellipsis">
            Paid by {paid_by}
          </Text>
        </Box>

        <Box flexDirection="column" marginRight="large" textAlign="right">
          <Text fontSize="medium">
            {/*
             // @ts-expect-error TS2769 */}
            {formatMoney(amount)}
          </Text>

          <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small">
            {paymentMethod}
          </Text>
        </Box>

        <IconWithMenu
          icon={(
            <Link greyLink>
              <FontAwesomeIcon icon={faCog} />
            </Link>
            )}
        >
          {/*
           // @ts-expect-error TS2741 */}
          <IconWithMenu.Menu closeOnClick>
            <Link href={campaignAccountingUrl}>
              <FontAwesomeIcon icon={faPencil} /> Manage Contribution
            </Link>

            {!payment_received && (
              <Link onClick={() => confirmDelete(confirmDeletePayload)}>
                <FontAwesomeIcon icon={faTrashAlt} />Delete Contribution
              </Link>
            )}

            <Link onClick={() => handleCallbackAction(updateCampaignContributionPayload)}>
              <FontAwesomeIcon icon={faCheckCircle} />
              {!payment_received ? 'Mark as Received' : 'Mark as Not Received'}
            </Link>
          </IconWithMenu.Menu>
        </IconWithMenu>
      </Box>
    </Box>
  )
}

export default ContributionsListItem
